// extracted by mini-css-extract-plugin
export var activeFilterButton = "_s4-c";
export var backButton = "_s4-4";
export var backIcon = "_s4-5";
export var chevronShortcut = "_s4-6";
export var container = "_s4-1";
export var editor = "_s4-8";
export var editorWrapper = "_s4-7";
export var prefix = "_s4-2";
export var searchIcon = "_s4-3";
export var suffix = "_s4-9";
export var suffixContent = "_s4-a";
export var suffixText = "_s4-b";
export var wrapper = "_s4-0";